__turbopack_context__.v({
  "button-expand": "meterReadingDetails-module-scss-module__mVJUZG__button-expand",
  "button-expand-icon": "meterReadingDetails-module-scss-module__mVJUZG__button-expand-icon",
  "button-submit-container": "meterReadingDetails-module-scss-module__mVJUZG__button-submit-container",
  "content": "meterReadingDetails-module-scss-module__mVJUZG__content",
  "image": "meterReadingDetails-module-scss-module__mVJUZG__image",
  "image-container": "meterReadingDetails-module-scss-module__mVJUZG__image-container",
  "image-container--loading": "meterReadingDetails-module-scss-module__mVJUZG__image-container--loading",
  "image-full": "meterReadingDetails-module-scss-module__mVJUZG__image-full",
  "image-modal": "meterReadingDetails-module-scss-module__mVJUZG__image-modal",
  "picture-full": "meterReadingDetails-module-scss-module__mVJUZG__picture-full",
  "status": "meterReadingDetails-module-scss-module__mVJUZG__status",
  "text-content": "meterReadingDetails-module-scss-module__mVJUZG__text-content",
  "withdraw": "meterReadingDetails-module-scss-module__mVJUZG__withdraw",
});
